import { z } from 'zod';
/** Publication status of a series. */
export const SERIES_STATUSES = ['ongoing', 'completed', 'cancelled', 'unknown'];
export const seriesStatusSchema = z.enum(SERIES_STATUSES);
/** Physical format of a series or single issue. */
export const PUBLICATION_FORMATS = [
    'issue',
    'magazine',
    'paperback',
    'hardcover',
    'album',
    'pocketbook',
    'manga',
    'omnibus',
    'other',
];
export const publicationFormatSchema = z.enum(PUBLICATION_FORMATS);
/** Where a record (or a single field) originally came from. */
export const DATA_SOURCES = [
    'manual',
    'metron',
    'gcd',
    'dnb',
    'openlibrary',
    'googlebooks',
    'comicvine',
];
export const dataSourceSchema = z.enum(DATA_SOURCES);
/**
 * Barcode families found on comics.
 * - `upc_a`: US floppies, 12 digits, usually with an EAN-5 add-on
 * - `ean_13`: generic 13 digit code
 * - `isbn_13`: EAN-13 with 978/979 prefix (paperbacks, albums, manga)
 * - `press_ean`: German newsstand code, add-on carries the issue number
 */
export const BARCODE_KINDS = ['upc_a', 'ean_13', 'isbn_13', 'press_ean', 'unknown'];
export const barcodeKindSchema = z.enum(BARCODE_KINDS);
/** Outcome of a single scan attempt. */
export const SCAN_RESULTS = ['found', 'not_found', 'ambiguous', 'duplicate', 'error'];
export const scanResultSchema = z.enum(SCAN_RESULTS);
/** Lifecycle of an unresolved scan sitting in the queue. */
export const SCAN_QUEUE_STATUSES = ['open', 'resolved', 'ignored'];
export const scanQueueStatusSchema = z.enum(SCAN_QUEUE_STATUSES);
/** Entities that can carry external identifiers. */
export const EXTERNAL_ENTITY_TYPES = ['publisher', 'series', 'issue'];
export const externalEntityTypeSchema = z.enum(EXTERNAL_ENTITY_TYPES);
/** Size variants generated for every stored image. */
export const IMAGE_VARIANTS = ['thumb', 'medium', 'large'];
export const imageVariantSchema = z.enum(IMAGE_VARIANTS);
//# sourceMappingURL=enums.js.map